import {BrowserModule} from '@angular/platform-browser';
import {LOCALE_ID, NgModule} from '@angular/core';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatButtonModule} from '@angular/material/button';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {MatCardModule} from '@angular/material/card';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatGridListModule} from '@angular/material/grid-list';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatListModule} from '@angular/material/list';
import {MatMenuModule} from '@angular/material/menu';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MAT_SNACK_BAR_DEFAULT_OPTIONS, MatSnackBar, MatSnackBarModule} from '@angular/material/snack-bar';
import {MatSortModule} from '@angular/material/sort';
import {MatTableModule} from '@angular/material/table';
import {MatTabsModule} from '@angular/material/tabs';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatTooltipModule} from '@angular/material/tooltip';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {ToolbarComponent} from './component/toolbar/toolbar.component';
import {SidenavComponent} from './component/sidenav/sidenav.component';
import {VorhersageComponent} from './component/thema/vorhersage/vorhersage.component';
import {MesswertComponent} from './component/thema/messwert/messwert.component';
import {TabnavComponent} from './component/tabnav/tabnav.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {DatePipe, registerLocaleData} from '@angular/common';
import localeDe from '@angular/common/locales/de';
import {SearchbarComponent} from './component/searchbar/searchbar.component';
import {UnwetterComponent} from './component/thema/unwetter/unwetter.component';
import {GesundheitComponent} from './component/thema/vorhersage/meteorologe/gesundheit/gesundheit.component';
import {PollenflugComponent} from './component/thema/vorhersage/meteorologe/gesundheit/pollenflug/pollenflug.component';
import {UvIndexComponent} from './component/thema/vorhersage/meteorologe/gesundheit/uv-index/uv-index.component';
import {OzonwerteComponent} from './component/thema/vorhersage/meteorologe/gesundheit/ozonwerte/ozonwerte.component';
import {HttpClientModule} from '@angular/common/http';
import {FirebaseService} from './service/firebase/firebase.service';
import {DateUtil} from './util/date-util';
import {AngularFireModule} from '@angular/fire';
import {environment} from '../environments/environment';
import {AngularFirestoreModule} from '@angular/fire/firestore';
import {BundeslandFilterService} from './service/bundeslandFilter/bundesland-filter.service';
import {LoginComponent} from './component/login/login.component';
import {AngularFireAuth} from '@angular/fire/auth';
import {NavListItemComponent} from './component/sidenav/nav-list-item/nav-list-item.component';
import {CommonConstants} from './util/common-constants';
import {ScrollingModule} from '@angular/cdk/scrolling';
import {RadarBilderAktuellComponent} from './component/thema/regeneradar/radar-bilder/radar-bilder-aktuell/radar-bilder-aktuell.component';
import {RadarBerichtComponent} from './component/thema/regeneradar/radar-bericht/radar-bericht.component';
import {PopUpFilterDialogComponent} from './component/pop-up-filter-dialog/pop-up-filter-dialog.component';
import {MatDialogModule} from '@angular/material/dialog';
import {MatChipsModule} from '@angular/material/chips';
import {MeteorologeComponent} from './component/thema/vorhersage/meteorologe/meteorologe.component';
import {BiowetterComponent} from './component/thema/vorhersage/meteorologe/gesundheit/biowetter/biowetter.component';
import {ComputerMosComponent} from './component/thema/vorhersage/computer-mos/computer-mos.component';
import {MatExpansionModule} from '@angular/material/expansion';
import {MesswertFilterComponent} from './component/thema/messwert/messwert-filter/messwert-filter.component';
import {MatStepperModule} from '@angular/material/stepper';
import {MatDividerModule} from '@angular/material/divider';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {VierundzwanzigStundenVorhersageComponent} from './component/thema/vorhersage/computer-mos/details/vierundzwanzig-stunden-vorhersage/vierundzwanzig-stunden-vorhersage.component';
import {DreiStundenVorhersageComponent} from './component/thema/vorhersage/computer-mos/details/drei-stunden-vorhersage/drei-stunden-vorhersage.component';
import {VierundzwanzigStundenVorhersageTableComponent} from './component/thema/vorhersage/computer-mos/details/vierundzwanzig-stunden-vorhersage/vierundzwanzig-stunden-vorhersage-table/vierundzwanzig-stunden-vorhersage-table.component';
import {DreiStundenVorhersageTableComponent} from './component/thema/vorhersage/computer-mos/details/drei-stunden-vorhersage/drei-stunden-vorhersage-table/drei-stunden-vorhersage-table.component';
import {ProgressIndicatorComponent} from './component/progress-indicator/progress-indicator.component';
import {AngularFireStorageModule} from '@angular/fire/storage';
import {WetterberichtComponent} from './component/thema/vorhersage/meteorologe/wetterbericht/wetterbericht.component';
import {RadiobremenComponent} from './component/thema/vorhersage/meteorologe/wetterbericht/radiobremen/radiobremen.component';
import {RadiobremenOnlineBerichtComponent} from './component/thema/vorhersage/meteorologe/wetterbericht/radiobremen/radiobremen-online-bericht/radiobremen-online-bericht.component';
import {RadiobremenVideotextBerichtComponent} from './component/thema/vorhersage/meteorologe/wetterbericht/radiobremen/radiobremen-videotext-bericht/radiobremen-videotext-bericht.component';
import {RadiobremenOzonBerichtComponent} from './component/thema/vorhersage/meteorologe/wetterbericht/radiobremen/radiobremen-ozon-bericht/radiobremen-ozon-bericht.component';
import {RadiobremenSpezialBerichtComponent} from './component/thema/vorhersage/meteorologe/wetterbericht/radiobremen/radiobremen-spezial-bericht/radiobremen-spezial-bericht.component';
import {WdrComponent} from './component/thema/vorhersage/meteorologe/wetterbericht/wdr/wdr.component';
import {WdrNordrheinWestfalenBerichtComponent} from './component/thema/vorhersage/meteorologe/wetterbericht/wdr/wdr-nordrhein-westfalen-bericht/wdr-nordrhein-westfalen-bericht.component';
import {WdrRegionenBerichtComponent} from './component/thema/vorhersage/meteorologe/wetterbericht/wdr/wdr-regionen-bericht/wdr-regionen-bericht.component';
import {WdrDeutschlandBerichtComponent} from './component/thema/vorhersage/meteorologe/wetterbericht/wdr/wdr-deutschland-bericht/wdr-deutschland-bericht.component';
import {WdrDeutschlandNordwestBerichtComponent} from './component/thema/vorhersage/meteorologe/wetterbericht/wdr/wdr-deutschland-nordwest-bericht/wdr-deutschland-nordwest-bericht.component';
import {WdrCosmoBerichtComponent} from './component/thema/vorhersage/meteorologe/wetterbericht/wdr/wdr-cosmo-bericht/wdr-cosmo-bericht.component';
import {WdrVideotextBerichtComponent} from './component/thema/vorhersage/meteorologe/wetterbericht/wdr/wdr-videotext-bericht/wdr-videotext-bericht.component';
import {BiowetterVorhersageComponent} from './component/thema/vorhersage/meteorologe/gesundheit/biowetter/biowetter-vorhersage/biowetter-vorhersage.component';
// tslint:disable-next-line:max-line-length
import {BiowetterZoneComponent} from './component/thema/vorhersage/meteorologe/gesundheit/biowetter/biowetter-zone/biowetter-zone.component';
import {UnwetterDetailComponent} from './component/thema/unwetter/unwetter-detail/unwetter-detail.component';
import {UvIndexDetailComponent} from './component/thema/vorhersage/meteorologe/gesundheit/uv-index/uv-index-detail/uv-index-detail.component';
import {MesswertTabelleComponent} from './component/thema/messwert/messwert-tabelle/messwert-tabelle.component';
import {WerteConverterUtil} from './util/werte-converter-util';
import {PollenflugRegionComponent} from './component/thema/vorhersage/meteorologe/gesundheit/pollenflug/pollenflug-region/pollenflug-region.component';
import {PollenflugBelastungsstufeComponent} from './component/thema/vorhersage/meteorologe/gesundheit/pollenflug/pollenflug-region/pollenflug-tag/pollenflug-belastungsstufe/pollenflug-belastungsstufe.component';
import {PollenflugTendenzComponent} from './component/thema/vorhersage/meteorologe/gesundheit/pollenflug/pollenflug-region/pollenflug-tag/pollenflug-tendenz/pollenflug-tendenz.component';
import {PollenflugTagComponent} from './component/thema/vorhersage/meteorologe/gesundheit/pollenflug/pollenflug-region/pollenflug-tag/pollenflug-tag.component';
import {RbbComponent} from './component/thema/vorhersage/meteorologe/wetterbericht/rbb/rbb.component';
import {BerlinBerichtComponent} from './component/thema/vorhersage/meteorologe/wetterbericht/rbb/berlin-bericht/berlin-bericht.component';
import {SchlagzeileWetterblitzBerichtComponent} from './component/thema/vorhersage/meteorologe/wetterbericht/rbb/schlagzeile-wetterblitz-bericht/schlagzeile-wetterblitz-bericht.component';
import {BerlinBrandenburgKurzBerichtComponent} from './component/thema/vorhersage/meteorologe/wetterbericht/rbb/berlin-brandenburg/berlin-brandenburg-kurz-bericht/berlin-brandenburg-kurz-bericht.component';
import {BerlinBrandenburgOnlineBerichtComponent} from './component/thema/vorhersage/meteorologe/wetterbericht/rbb/berlin-brandenburg/berlin-brandenburg-online-bericht/berlin-brandenburg-online-bericht.component';
import {BerlinBrandenburgVideotextBerichtComponent} from './component/thema/vorhersage/meteorologe/wetterbericht/rbb/berlin-brandenburg/berlin-brandenburg-videotext-bericht/berlin-brandenburg-videotext-bericht.component';
import {BrandenburgLangBerichtComponent} from './component/thema/vorhersage/meteorologe/wetterbericht/rbb/berlin-brandenburg/brandenburg-lang-bericht/brandenburg-lang-bericht.component';
import {InforadioTextBerichtComponent} from './component/thema/vorhersage/meteorologe/wetterbericht/rbb/berlin-brandenburg/inforadio-text-bericht/inforadio-text-bericht.component';
import {DeutschlandwetterBerichtComponent} from './component/thema/vorhersage/meteorologe/wetterbericht/rbb/deutschlandwetter-bericht/deutschlandwetter-bericht.component';
import {VierundzwanzigStundenVorhersageTableDetailComponent} from './component/thema/vorhersage/computer-mos/details/vierundzwanzig-stunden-vorhersage/vierundzwanzig-stunden-vorhersage-table/vierundzwanzig-stunden-vorhersage-table-detail/vierundzwanzig-stunden-vorhersage-table-detail.component';
import {DreiStundenVorhersageTableDetailComponent} from './component/thema/vorhersage/computer-mos/details/drei-stunden-vorhersage/drei-stunden-vorhersage-table/drei-stunden-vorhersage-table-detail/drei-stunden-vorhersage-table-detail.component';
import {RbbBiowetterBerichtComponent} from './component/thema/vorhersage/meteorologe/wetterbericht/rbb/biowetter-bericht/rbb-biowetter-bericht.component';
import {AutomatisiertComponent} from './component/thema/vorhersage/automatisiert/automatisiert.component';
import {AutomatisiertBrandenburgAktuellComponent} from './component/thema/vorhersage/automatisiert/automatisiert-brandenburg-aktuell/automatisiert-brandenburg-aktuell.component';
import {AutomatisiertRbbAktuellComponent} from './component/thema/vorhersage/automatisiert/automatisiert-rbb-aktuell/automatisiert-rbb-aktuell.component';
import {BreadcrumbComponent} from './component/breadcrumb/breadcrumb.component';
import {UserMenuComponent} from './component/user-menu/user-menu.component';
import {WetterKartePdfBerichtComponent} from './component/thema/vorhersage/meteorologe/wetterbericht/rbb/wetter-karte-pdf-bericht/wetter-karte-pdf-bericht.component';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {GridnavComponent} from './component/gridnav/gridnav.component';
import {GridnavItemComponent} from './component/gridnav/gridnav-item/gridnav-item.component';
import {DetailExpansionPanelComponent} from './component/thema/unwetter/unwetter-detail/detail-warnung/detail-expansion-panel/detail-expansion-panel.component';
import {DetailWarnungComponent} from './component/thema/unwetter/unwetter-detail/detail-warnung/detail-warnung.component';
import {SpezialwetterBerichtComponent} from './component/thema/vorhersage/meteorologe/wetterbericht/rbb/spezialwetter-bericht/spezialwetter-bericht.component';
import {SonstigesComponent} from './component/thema/sonstiges/sonstiges.component';
import {AstrowetterComponent} from './component/thema/sonstiges/rbb-sonstiges-wetter/astrowetter/astrowetter.component';
import {RbbWintersportWetterWerteComponent} from './component/thema/vorhersage/meteorologe/freizeit-wetter/wintersport-wetter/rbb-wintersport-wetter/rbb-wintersport-wetter-werte/rbb-wintersport-wetter-werte.component';
import {RbbWintersportWetterTexteComponent} from './component/thema/vorhersage/meteorologe/freizeit-wetter/wintersport-wetter/rbb-wintersport-wetter/rbb-wintersport-wetter-texte/rbb-wintersport-wetter-texte.component';
import {RbbSonstigesWetterComponent} from './component/thema/sonstiges/rbb-sonstiges-wetter/rbb-sonstiges-wetter.component';
import {FreizeitWetterComponent} from './component/thema/vorhersage/meteorologe/freizeit-wetter/freizeit-wetter.component';
import {WintersportWetterComponent} from './component/thema/vorhersage/meteorologe/freizeit-wetter/wintersport-wetter/rbb-wintersport-wetter/wintersport-wetter.component';
import {WassersportWetterComponent} from './component/thema/vorhersage/meteorologe/freizeit-wetter/wassersport-wetter/wassersport-wetter.component';
import {RbbWassersportWetterComponent} from './component/thema/vorhersage/meteorologe/freizeit-wetter/wassersport-wetter/rbb-wassersport-wetter/rbb-wassersport-wetter.component';
import {RadarBilderVorhersagenComponent} from './component/thema/regeneradar/radar-bilder/radar-bilder-vorhersagen/radar-bilder-vorhersagen.component';
import {MatBadgeModule} from '@angular/material/badge';
import {BrComponent} from './component/thema/vorhersage/meteorologe/wetterbericht/br/br.component';
import {BrAbendschauwetterBerichtComponent} from './component/thema/vorhersage/meteorologe/wetterbericht/br/br-abendschauwetter-bericht/br-abendschauwetter-bericht.component';
import {BrSiebentagewetterBerichtComponent} from './component/thema/vorhersage/meteorologe/wetterbericht/br/br-siebentagewetter-bericht/br-siebentagewetter-bericht.component';
import {BrRundschauwetterBerichtComponent} from './component/thema/vorhersage/meteorologe/wetterbericht/br/br-rundschauwetter-bericht/br-rundschauwetter-bericht.component';
import {BrBergwetterBerichtComponent} from './component/thema/vorhersage/meteorologe/wetterbericht/br/br-bergwetter-bericht/br-bergwetter-bericht.component';
import {BrRegionalwetterBerichtComponent} from './component/thema/vorhersage/meteorologe/wetterbericht/br/br-regionalwetter-bericht/br-regionalwetter-bericht.component';
import {BrBiowetterBerichtComponent} from './component/thema/vorhersage/meteorologe/wetterbericht/br/br-biowetter-bericht/br-biowetter-bericht.component';
import {BrKurzwetterBerichtComponent} from './component/thema/vorhersage/meteorologe/wetterbericht/br/br-kurzwetter-bericht/br-kurzwetter-bericht.component';
import {BrLangwetterBerichtComponent} from './component/thema/vorhersage/meteorologe/wetterbericht/br/br-langwetter-bericht/br-langwetter-bericht.component';


registerLocaleData(localeDe);


@NgModule({
  entryComponents: [],
  declarations: [
    AppComponent,
    ToolbarComponent,
    SidenavComponent,
    VorhersageComponent,
    MesswertComponent,
    TabnavComponent,
    SearchbarComponent,
    UnwetterComponent,
    GesundheitComponent,
    PollenflugComponent,
    UvIndexComponent,
    OzonwerteComponent,
    LoginComponent,
    NavListItemComponent,
    RadarBilderAktuellComponent,
    RadarBerichtComponent,
    PopUpFilterDialogComponent,
    MeteorologeComponent,
    BiowetterVorhersageComponent,
    BiowetterZoneComponent,
    BiowetterComponent,
    ComputerMosComponent,
    MesswertFilterComponent,
    VierundzwanzigStundenVorhersageComponent,
    DreiStundenVorhersageComponent,
    VierundzwanzigStundenVorhersageTableComponent,
    VierundzwanzigStundenVorhersageTableDetailComponent,
    DreiStundenVorhersageTableComponent,
    DreiStundenVorhersageTableDetailComponent,
    ProgressIndicatorComponent,
    WetterberichtComponent,
    RadiobremenComponent,
    RadiobremenOnlineBerichtComponent,
    RadiobremenVideotextBerichtComponent,
    RadiobremenOzonBerichtComponent,
    RadiobremenSpezialBerichtComponent,
    WdrComponent,
    BrComponent,
    WdrNordrheinWestfalenBerichtComponent,
    WdrRegionenBerichtComponent,
    WdrDeutschlandBerichtComponent,
    WdrDeutschlandNordwestBerichtComponent,
    WdrCosmoBerichtComponent,
    WdrVideotextBerichtComponent,
    UnwetterDetailComponent,
    UvIndexDetailComponent,
    MesswertTabelleComponent,
    PollenflugRegionComponent,
    PollenflugBelastungsstufeComponent,
    PollenflugTendenzComponent,
    PollenflugTagComponent,
    RbbComponent,
    BerlinBerichtComponent,
    SchlagzeileWetterblitzBerichtComponent,
    BerlinBrandenburgKurzBerichtComponent,
    BerlinBrandenburgOnlineBerichtComponent,
    BerlinBrandenburgVideotextBerichtComponent,
    BrandenburgLangBerichtComponent,
    InforadioTextBerichtComponent,
    DeutschlandwetterBerichtComponent,
    RbbBiowetterBerichtComponent,
    AutomatisiertComponent,
    AutomatisiertBrandenburgAktuellComponent,
    AutomatisiertRbbAktuellComponent,
    BreadcrumbComponent,
    UserMenuComponent,
    WetterKartePdfBerichtComponent,
    GridnavComponent,
    GridnavItemComponent,
    DetailExpansionPanelComponent,
    DetailWarnungComponent,
    SpezialwetterBerichtComponent,
    SonstigesComponent,
    AstrowetterComponent,
    RbbWintersportWetterWerteComponent,
    RbbWintersportWetterTexteComponent,
    RbbSonstigesWetterComponent,
    FreizeitWetterComponent,
    WintersportWetterComponent,
    RbbWassersportWetterComponent,
    WassersportWetterComponent,
    RbbWassersportWetterComponent,
    RadarBilderVorhersagenComponent,
    BrAbendschauwetterBerichtComponent,
    BrSiebentagewetterBerichtComponent,
    BrRundschauwetterBerichtComponent,
    BrBergwetterBerichtComponent,
    BrRegionalwetterBerichtComponent,
    BrBiowetterBerichtComponent,
    BrKurzwetterBerichtComponent,
    BrLangwetterBerichtComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFirestoreModule,
    AngularFireStorageModule,
    BrowserAnimationsModule,
    MatMenuModule,
    MatIconModule,
    MatButtonModule,
    MatToolbarModule,
    MatSidenavModule,
    MatListModule,
    MatButtonToggleModule,
    MatCheckboxModule,
    MatGridListModule,
    MatCardModule,
    MatTabsModule,
    FormsModule,
    MatAutocompleteModule,
    MatInputModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatSnackBarModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    ReactiveFormsModule,
    ScrollingModule,
    MatDialogModule,
    MatChipsModule,
    MatExpansionModule,
    MatStepperModule,
    MatDividerModule,
    MatProgressBarModule,
    MatSlideToggleModule,
    MatBadgeModule
  ],
  providers: [
    {provide: LOCALE_ID, useValue: 'de-DE'},
    {provide: MAT_SNACK_BAR_DEFAULT_OPTIONS, useValue: {duration: 2500}},
    CommonConstants,
    WerteConverterUtil,
    BundeslandFilterService,
    MatSnackBar, FirebaseService,
    AngularFireAuth,
    DatePipe, DateUtil],
  bootstrap: [AppComponent]
})
export class AppModule {
}
